
const __default__ = {
  data(){
    return {
      visible: false
    }
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'modify',
  emits: ['ask-ai'],
  setup(__props, { expose: __expose }) {
  __expose();



const ACTIONS = [
  {
    name: 'Creative',
    icon: 'edit-04',
    prompt: 'Make it more creative and engaging. Use a variety of expressions and introduce some novel ideas. --temp 0.9'
  },
  {
    name: 'Friendly',
    icon: 'message-smile-circle',
    prompt: 'Make it friendlier and more approachable. Use a conversational tone and warm language'
  },
  {
    name: 'Professional',
    icon: 'luggage-02',
    prompt: 'Make it more professional. Ensure the language is formal and the tone is appropriate for a business audience'
  },
  {
    name: 'Concise',
    icon: 'align-vertical-center-01',
    prompt: 'Make it more concise. Focus on brevity and clarity, removing any unnecessary words or phrases'
  },
  {
    name: 'Key points',
    icon: 'list',
    prompt: 'Make it highlight the key points. Ensure the main ideas are clear and easily identifiable'
  }
]

const __returned__ = { ACTIONS }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})